module.exports = __webpack_public_path__ + "media/images/go-209b42e3ae5cfb934263e9a67f8eec99.svg";